import clsx from 'clsx'
import {useContext, useState} from 'react'
import {CustomerContext} from '../CustomerContext'
import {DateRangeProvider} from '@/components/context/DateRangeContext'
import PaymentReportPane from './panes/PaymentReportPane'
import OrderReportPane from './panes/OrderReportPane'
import EarningsReportPane from './panes/EarningsReportPane'

type TabProps = {
  key: string
  label: string
}

const tabs : TabProps[] = [{
  key: 'payment', 'label': 'Payment',
}, {
  key: 'order', 'label': 'Orders',
}, {
  key: 'earnings', 'label': 'Earnings',
}]

const Reports = () => {
  const { customer } = useContext(CustomerContext)
  const [tab, setTab] = useState<string>('payment')

  if (!customer) {
    return (<></>)
  }

  return (
    <DateRangeProvider
      defaultRange="month"
      minDate={new Date(customer.createdAt)}
      maxDate={new Date()}
      middleContent={
        <ul className="pagination">
          {tabs.map((t: TabProps) => (
            <li className="page-item" key={`report-tab-${t.key}`}>
              <button
                className={clsx('btn btn-sm btn-active btn-active-primary me-3', {
                  'btn-primary active': t.key === tab,
                  'btn-secondary ': t.key !== tab
                })}
                onClick={()=> setTab(t.key)}
                disabled={t.key === tab}
              >
                {t.label}
              </button>
            </li>
          ))}
        </ul>
      }
    >
      {tab === 'payment' ? (
        <PaymentReportPane />
      ) : tab === 'order' ? (
        <OrderReportPane />
      ) : (
        <EarningsReportPane />
      )}
    </DateRangeProvider>
  )
}

export default Reports
